module.exports = __webpack_public_path__ + "static/img/img2.7dbd4453.png";